export const aboutContent = {
  hero: {
    title: "Spiritual Regeneration Is Soil Regeneration",
    quote: "Earth Rights Business is as much about spiritual regeneration as it is about soil regeneration"
  },
  why: {
    title: "There's Too Much Money and Not Enough Value",
    opener: "We are aligning the mentality of environmentalism with the action of putting money in the hands of regenerative land managers.",
    text: "Our economic incentive system is disconnected from basic human needs. The mainstream dialog concerning environmentalism is outdated because it is fixated on demonizing carbon while ignoring soil, the obvious solution. Farming was invented to secure food. Now farming is the problem that is eating away at the soil. We have forgotten how to incorporate feeding the soil into the process of growing food. The soil doesn't have a voice in business. It doesn't sit at the table where decisions are made. Meanwhile, it degrades—and with it, our food, our health, our future.",
    quote: "Money is make believe. We believe making soil rich is worth money."
  },
  reframe: {
    title: "A Movement That Speaks for the Earth",
    text: "ERB gives soil a seat at the table through the power of collective consumer voice. Supporting Regenerative farms builds soil, Joining the ERB movement is becoming part of a group of soil builders. Each person in our community is a representation of a healthy cell. As our community grows it is laying the tract for a digestible system of production. \u201CRegenerative communities are Earth\u2019s healthy cognitive connective tissues capable of manifesting a global health movement\u201D We\u2019re not a charity. We\u2019re not a corporation. We\u2019re a MOVEMENT\u2014a growing group of people who believe that how we spend money should regenerate, not deplete.",
    quotes: [
      "Our tokenized alphabet symbolizes the power of a unified voice for the general brand of Earth\u2019s soil.",
      "Show a sign you are open for service to the soil"
    ]
  },
  mechanism: {
    title: "How Art Becomes Action",
    description: "When you purchase ERB art, you\u2019re not just buying a collectible. You\u2019re funding a financial instrument that:",
    items: [
      "Spreads the message autonomously \u2014 blockchain art incentivises attention",
      "Grows in influence \u2014 more holders = louder voice",
      "Keeps a record for future rewards",
      "Directs resources \u2014 proceeds support regenerative land management",
      "Builds toward certification \u2014 creating standards for regenerative business"
    ],
    quote: "The intrinsic quality of art programmed into the blockchain provides the utility of the message to function as a basic financial instrument."
  },
  transformation: {
    title: "The Transformation Path",
    stages: [
      {
        title: "Art of Spelling",
        description: "Release what no longer serves"
      },
      {
        title: "Alphabet Soup",
        description: "Transform the old into nourishment"
      },
      {
        title: "Kepri Scarab",
        description: "Rise from the process renewed"
      }
    ]
  },
  community: {
    title: "Decentralized Down to the Dirt",
    items: [
      "Local maximalism \u2014 supporting regenerative farms in your community",
      "Horizontal outreach \u2014 consumer-driven growth, not top-down marketing",
      "Vertical integration \u2014 from global message to local soil"
    ],
    text: "The local regenerative farm is acting as the decentralized bank for the global brand of soil. By connecting and supporting your local farm you are helping the individual brands to grow but also the global regenerative consciousness in commerce.",
    quote: "Local regenerative farms are the actual brands our meritocracy of messaging connects to in tangible reality."
  },
  closing: {
    quote: "This is the super natural evolution of business",
    description: "Join the movement"
  }
};
